import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { User } from "@/domains/auth/api/types";
import { SEED_USERS, findUserById } from "@/domains/auth/mocks/users";

const DEFAULT_USER = SEED_USERS.find((u) => u.role === "manager") ?? SEED_USERS[0];

const currentUserIdAtom = atomWithStorage<string>("pza.currentUserId", DEFAULT_USER.id, undefined, { getOnInit: true });

export const currentUserAtom = atom(
  (get): User => findUserById(get(currentUserIdAtom)) ?? DEFAULT_USER,
  (_get, set, user: User) => {
    set(currentUserIdAtom, user.id);
  },
);

export const isAuthenticatedAtom = atomWithStorage<boolean>(
  "pza.isAuthenticated",
  false,
  undefined,
  { getOnInit: true },
);
